import { Component, type ErrorInfo, type ReactNode } from "react";

export class ScreenErrorBoundary extends Component<{ children: ReactNode; title?: string }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="page">
        <h1 className="serif">{this.props.title ?? "This screen needs a correction"}</h1>
        <p>The shared trip loaded, but this view could not be calculated. Nothing was deleted. The owner can open Edit or Money after the record is corrected.</p>
        <p className="muted">{this.state.error.message}</p>
        <button className="btn" type="button" onClick={() => this.setState({ error: null })}>Try again</button>
      </main>
    );
  }
}
